import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { PublishTranslationCompleteEventRequest } from '@cash-web/shared-util-protos/squareup/cash/cashlingo/core/core_service.pb'
import { PublishTranslationCompleteEventResponse } from '@cash-web/shared-util-protos/squareup/cash/cashlingo/core/core_service.pb'

export const publishTranslationCompleteEvent = (
  request: PublishTranslationCompleteEventRequest,
  options?: CashRequestOptions
) =>
  post<PublishTranslationCompleteEventRequest, PublishTranslationCompleteEventResponse>(
    '/2.0/cash/publish-translation-complete-event',
    request,
    { ...options, rejectOnError: true }
  )
